<mode-channel-component
  [channelSummary]="channelSummary"
  [encoding]="encoding"
  [model]="model"
  [view]="view"
  [chartService]="chartService"
  [chartType]="chartType"
  [fieldFormatMap]="fieldFormatMap"
  [format]="format"
  [series]="series"
  [queryToken]="queryToken"
  [vizToken]="vizToken"
  [allowScalars]="true"
  [allowAggregates]="true"
  [allowDiscrete]="true"
  [allowContinuous]="true"
  [allowBinned]="true"
  [binSizeToFieldMap]="binSizeToFieldMap"
>
  <capra-icon
    (click)="openTextModal()"
    class="text-icon"
    [class.button]="isEnabled"
    icon="icon-mark-label"
  ></capra-icon>
</mode-channel-component>
